<template>
  <div>
    <!-- <v-toolbar flat class="editBG">
      <v-toolbar-title class="elevation-0">Selections</v-toolbar-title> -->
      <!-- <v-divider class="mx-2" inset vertical></v-divider> -->
      <!-- <v-spacer></v-spacer> -->
    <!-- </v-toolbar> -->

    <v-card-title >
      <v-toolbar-title class="elevation-0 ml-3 pt-3 pb-0">Selections containing this Artwork </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-text-field
        class="mr-3"
        append-icon="search"
        label="Search "
        single-line
        clearable
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :search="search"
      :headers="headers"
      :items="selections"
      item-key="id"
      class="elevation-2 mx-4"
      v-model="selected"
      :pagination.sync="p"
    >
      <template slot="items" slot-scope="props">
        <!-- <td class="py-2 text-xs-right"><v-checkbox primary hide-details v-model="props.selected"></v-checkbox></td> -->
        <td class="py-2 text-xs-left px-4">{{ props.item.name }}</td>
        <td class="py-2 text-xs-center px-4">
          {{ props.item.artworks.length }}
        </td>
        <td class="py-2 text-xs-center px-4">
          {{ get_user(props.item.created_by) }}
        </td>
        <td class="py-2 text-xs-center px-4">
          {{ format_date(props.item.created_at) }}
        </td>
        <td class="py-2 text-xs-center px-4">
          <span v-if="props.item.updated_at">{{
            format_date(props.item.updated_at)
          }}</span>
        </td>
        <!-- <td class="justify-center d-flex">
          <v-btn flat icon small>
            <v-icon small class @click="duplicateItem(props.item)"
              >file_copy</v-icon
            >
          </v-btn>
          <v-btn flat icon small>
            <v-icon small class @click="editItem(props.item)">edit</v-icon>
          </v-btn>
          <v-btn flat icon small v-if="c_user.delete_rights">
            <v-icon small @click="showDeleteDialog(props.item)">delete</v-icon>
          </v-btn>
        </td> -->
      </template>
      <template slot="no-data">
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
        <center>No data available</center>
      </template>
    </v-data-table>
  </div>
</template>

<script>
function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function(a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
import axios from "axios";
export default {
  // mixins: [ CommonMixin ],
  props: ["artwork"],
  data: () => ({
    selected: [],
    search: "",
    menu_storage_out: false,
    menu_storage_in: false,
    dialog: false,
    deleteDialog: false,
    itemToDelete: null,
    dialog2: false,
    headers: [
      { text: "Title", align: "left", sortable: true, value: "name" },
      {
        text: "Selection Artworks Count",
        align: "center",
        sortable: true,
        value: "artworks.length"
      },
      {
        text: "Created by",
        align: "center",
        value: "created_by",
        sortable: true
      },
      {
        text: "Created at",
        align: "center",
        value: "created_at",
        sortable: true
      },
      {
        text: "Updated at",
        align: "center",
        value: "updated_at",
        sortable: true
      }
      // { text: "Actions", align: "right", sortable: false, align: "center" }
    ],
    editedIndex: -1,
    show: false,
    showUpload: false,
    p: {
      descending: true,
      rowsPerPage: 10,
      sortBy: "created_at"
    }
  }),
  computed: {
    selections() {
      return this.$store.state.lists.filter(s =>
        s.artworks.includes(this.artwork.id)
      );
    },
    // visa_status () {
    //   this.constants.VISA_STATUSES.find(this.artwork.visa_status)
    // },
    all_packings() {
      return this.$store.state.packings;
      // console.log(todos)
      // return todos
    },
    selection_items() {
      var artwork_locations = Object.assign([], this.$store.state.locations);
      return artwork_locations.sort(dynamicSort("name"));
    }
  },
  methods: {
    newItem() {
      this.dialog = true;
      this.packing = {
        packing: "",
        height: "",
        lenght: "",
        width: "",
        weight: "",
        contents: "",
        colli: "",
        visa_status: "",
        artwork_id: "",
        artwork_location_id: ""
      };
    },
    editItem(i) {
      this.packing = {
        packing: "",
        height: "",
        lenght: "",
        width: "",
        weight: "",
        contents: "",
        colli: "",
        visa_status: "",
        artwork_id: "",
        artwork_location_id: ""
      };
      this.saving = false;
      this.editing = true;
      this.dialog = true;
      try {
        this.packing = Object.assign(
          {},
          this.artwork.artwork_packings.find(t => t.id == i.id)
        );
      } catch (error) {
        // console.log(error.message);
      }
    },
    saveField() {
      setTimeout(() => {
        let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`;
        axios
          .put(url, {
            field_name: "transport_history",
            field_value: this.artwork.transport_history
          })
          .then(response => {
            this.progress = false;
          })
          .catch(error => {
            // console.log(error)
          });
      }, 1000);
    },
    close() {
      this.dialog = false;
    },
    // initialize () {},
    showDeleteDialog(p) {
      this.itemToDelete = p;
      this.deleteDialog = true;
    },
    deleteItem() {
      const index = this.artwork.artwork_packings.indexOf(this.itemToDelete);
      var i = this.artwork.artwork_packings.indexOf(this.itemToDelete);
      if (i != -1) {
        this.artwork.artwork_packings.splice(i, 1);
      }
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      this.$store.dispatch("deletePacking", this.itemToDelete);
      this.itemToDelete = null;
      this.deleteDialog = false;
    },
    cancelDelete() {
      this.deleteDialog = false;
      this.itemToDelete = null;
    },
    // delete_packing () {},
    get_visa_status(packing) {
      var vss = this.constants.VISA_STATUSES.filter(
        vs => vs.id === packing.visa_status
      );
      if (vss[0] != undefined) {
        // console.log(vss[0].id)
        return vss[0].id > 0 ? vss[0].name : "";
      } else {
        return "";
      }
    },
    // get_location_name(packing) {
    //   var l = this.$store.state.locations.find(
    //     l => l.id === packing.artwork_location_id
    //   );
    //   return l ? l.name : "";
    // },
    duplicateItem(p) {
      // console.log(p)
      var packing = Object.assign({}, p);
      delete packing.id;
      // console.log(this.packing)
      packing.artwork_id = this.artwork.id;
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      // this.packing.reject { |k,v| k == :id }
      axios
        .post(`${this.$globals.apiserver}/artwork_packings.json`, {
          packing: packing
        })
        .then(response => {
          this.errors = {};
          this.artwork.artwork_packings.push(response.data);
          this.$store.commit("ADD_PACKING", response.data);
        })
        .catch(error => {
          this.errors = error.response.data;
        });
      // console.log(this.packing)
      // this.all_packings.push(this.packing)
      this.showUpload = !this.showUpload;
      this.dialog = false;
      this.packing = {
        packing: "",
        height: "",
        width: "",
        packing: "",
        lenght: "",
        weight: "",
        contents: "",
        note: "",
        visa_status: 0,
        colli: "",
        visa_status: "",
        artwork_location_id: ""
      };
    },
    save() {
      this.saving = true;
      this.packing.artwork_id = this.artwork.id;
      // this.packing.id = this.findMinMax(this.all_packings)+1
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      // this.artwork.artwork_packings.push(this.packing)
      if (this.editing) {
        let url = `${this.$globals.apiserver}/artwork_packings/${this.packing.id}.json`;
        axios
          .put(url, {
            packing: this.packing
          })
          .then(response => {
            this.errors = {};
            this.artwork.artwork_packings = [
              ...this.artwork.artwork_packings.map(item =>
                item.id !== response.data.id
                  ? item
                  : { ...item, ...response.data }
              )
            ];
            this.$store.commit("SAVE_PACKING", response.data);
            this.dialog = false;
            this.packing = {
              packing: "",
              height: "",
              width: "",
              packing: "",
              lenght: "",
              weight: "",
              contents: "",
              note: "",
              visa_status: 0,
              colli: "",
              visa_status: "",
              artwork_location_id: ""
            };
            this.saving = false;
            this.editing = false;
          })
          .catch(error => {
            this.save_error = true;
          });
      } else {
        axios
          .post(`${this.$globals.apiserver}/artwork_packings.json`, {
            packing: this.packing
          })
          .then(response => {
            this.errors = {};
            this.artwork.artwork_packings.push(response.data);
            this.$store.commit("ADD_PACKING", response.data);
          })
          .catch(error => {
            this.errors = error.response.data;
          });
        // console.log(this.packing)
        // this.all_packings.push(this.packing)
        this.dialog = false;
        this.packing = {
          packing: "",
          height: "",
          width: "",
          packing: "",
          lenght: "",
          weight: "",
          contents: "",
          note: "",
          visa_status: 0,
          colli: "",
          visa_status: "",
          artwork_location_id: ""
        };
      }
    },
    update_multiple() {
      this.updated_packing.artwork_id = this.artwork.id;
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      axios
        .get(
          `${this.$globals.apiserver}/artwork_packings/update_multiple.json`,
          {
            updated_packing: this.updated_packing,
            selected: this.selected
          }
        )
        .then(response => {
          this.errors = {};
          this.artwork.artwork_packings = [];
          this.artwork.artwork_packings.push(response.data);
          // this.$store.commit('REPLACE_PACKING', response.data)
        })
        .catch(error => {
          this.errors = error.response.data;
        });
      this.dialog2 = !this.dialog2;
      // this.dialog = false
      this.updated_packing = {
        packing: "",
        height: "",
        width: "",
        packing: "",
        length: "",
        weigth: "",
        contents: "",
        note: "",
        visa_status: 0
      };
    }
  }
};
</script>

<style scoped>
.card {
  min-width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/Selections.vue